{
  "fieldList": {
    "addField": {
      "label": "Ajouter un champ",
      "placeholder": "Nom du champ",
      "typeLabel": "Type",
      "addButton": "Ajouter"
    },
    "search": {
      "placeholder": "Rechercher des champs..."
    },
    "filters": {
      "all": "tous",
      "mapped": "mappés",
      "unmapped": "non mappés"
    },
    "actions": {
      "rename": "Renommer le champ",
      "clone": "Cloner le champ",
      "delete": "Supprimer le champ"
    },
    "deleteDialog": {
      "title": "Supprimer le champ",
      "body": "Voulez-vous vraiment supprimer le champ \"{{fieldName}}\" ?"
    },
    "validation": {
      "fieldNameRequired": "Le nom du champ est requis",
      "invalidFieldName": "Nom de champ invalide"
    },
    "empty": "Aucun champ trouvé",
    "accordion": {
      "summary": "Champs ({{mappedCount}}/{{totalCount}} mappés)"
    },
    "typeOverride": {
      "chip": "→ {{type}}"
    }
  },
  "batchUpload": {
    "title": "Importation en lot de champs",
    "button": "Importation en lot",
    "uploadStep": "Téléversez un fichier CSV",
    "selectFieldNameColumn": "Sélectionnez la colonne contenant les noms de champ",
    "selectFieldTypeColumn": "Colonne du type de champ (optionnel)",
    "mappingHelpText": "Mappez chaque colonne à une cible avant de continuer. Une seule colonne peut être mappée au nom du champ, et au maximum une au type du champ.",
    "previewRowsHint": "Affichage des {{count}} premières lignes sur {{total}} lignes au total",
    "none": "Aucun",
    "fileLoaded": "{{fileName}} chargé",
    "stepLabel": "Étape {{current}} sur {{total}}",
    "emptyNameValue": "(vide)",
    "nextButton": "Suivant",
    "backButton": "Retour",
    "cancelButton": "Annuler",
    "importButton": "Importer les champs",
    "status": {
      "willAdd": "Sera ajouté",
      "duplicateExisting": "Dupliqué (ignoré)",
      "duplicateCsv": "Dupliqué dans le CSV (ignoré)",
      "emptyName": "Nom vide (ignoré)",
      "unknownType": "Type inconnu \"{{rawType}}\" (utilise TextField)"
    },
    "preview": {
      "title": "Aperçu",
      "fieldsToAdd": "{{count}} champs seront ajoutés",
      "duplicatesSkipped": "{{count}} doublons seront ignorés",
      "unknownTypeDefaulted": "{{count}} avec type inconnu converti en TextField",
      "columns": {
        "fieldName": "Nom du champ",
        "fieldType": "Type du champ",
        "status": "Statut"
      }
    },
    "errors": {
      "parseFailed": "Échec de l'analyse du fichier CSV"
    },
    "mappingOptions": {
      "ignore": "Ignorer",
      "fieldName": "Nom du champ",
      "fieldType": "Type du champ"
    }
  },
  "fieldMapping": {
    "fieldType": {
      "label": "Type de champ"
    },
    "typeOverridden": "(remplacé)",
    "advanced": {
      "label": "Avancé"
    },
    "dataMasking": {
      "label": "Masquage des données",
      "noRules": "Aucune règle de masquage ajoutée pour l'instant.",
      "addRule": "Ajouter une règle de masquage",
      "pdfExportOnValueColumn": "Valeur d'exportation PDF activée",
      "maskValueColumn": "Valeur de masquage",
      "exactValuePlaceholder": "Valeur exacte",
      "maskValuePlaceholder": "Saisir la valeur de masquage",
      "resetMask": "Réinitialiser le masque à la valeur PDF activée",
      "optionColumn": "Choix"
    },
    "formatter": {
      "label": "Formateur"
    },
    "defaultValue": {
      "label": "Valeur par défaut",
      "placeholder": "Valeur de repli si vide"
    },
    "errorWhenEmpty": {
      "label": "Erreur si vide"
    }
  },
  "settings": {
    "moreSettings": "Plus de paramètres",
    "title": "Paramètres de la carte de formulaire",
    "esignSection": "Signature électronique",
    "pdfSection": "Sortie PDF",
    "signaturePageNumberBase": {
      "label": "Base du numéro de page de signature",
      "help": "Utilisez UN pour DocuSign, ZÉRO pour OneSpan",
      "one": "UN (base 1)",
      "zero": "ZÉRO (base 0)"
    },
    "removePdfMaxLength": {
      "label": "Supprimer la longueur maximale du PDF"
    },
    "language": {
      "label": "Langue",
      "options": {
        "en": "Anglais",
        "es": "Espagnol",
        "fr": "Français"
      }
    }
  },
  "testPanel": {
    "eSignProvider": {
      "label": "Fournisseur de signature électronique",
      "helpText": "Système de coordonnées utilisé pour l'emplacement des champs de signature",
      "options": {
        "rawPdf": "PDF brut (en bas à gauche, 72 DPI)",
        "docusign": "DocuSign (en haut à gauche, 72 DPI)",
        "onespan": "OneSpan (en haut à gauche, 93,6 DPI)"
      }
    },
    "signatureFieldLocations": {
      "title": "Emplacements des champs de signature"
    }
  },
  "replacePdf": {
    "button": "Remplacer le PDF",
    "unsavedLabel": "PDF non enregistré",
    "revert": "Annuler les modifications",
    "confirmTitle": "Remplacer le modèle PDF ?",
    "confirmCurrent": "Actuel : {{file}}",
    "confirmNew": "Nouveau : {{file}}",
    "confirmMatchHeading": "Correspondance des champs avec cette carte :",
    "confirmKept": "{{count}} étiquettes toujours sur le nouveau PDF (conservées)",
    "confirmMissing": "{{count}} étiquettes manquantes du nouveau PDF (conservées comme extras)",
    "confirmAdded": "{{count}} nouveaux widgets sans mappage (vides)",
    "confirmFooter": "Les mappages de champs existants seront fusionnés par nom. Le nouveau PDF n'est pas enregistré tant que vous n'avez pas cliqué sur Mettre à jour.",
    "errorReading": "Erreur lors de la lecture du PDF. Assurez-vous qu'il contient des champs de formulaire à remplir."
  }
}
